import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var BeginDiscordOAuthInputClass;
function BeginDiscordOAuthInput() {
  if (BeginDiscordOAuthInputClass === VOID) {
    class $ {
      constructor(partyId, challenge) {
        this.f6t_1 = partyId;
        this.g6t_1 = challenge;
      }
      toString() {
        return 'BeginDiscordOAuthInput(partyId=' + this.f6t_1.toString() + ', challenge=' + this.g6t_1 + ')';
      }
      hashCode() {
        var result = this.f6t_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.g6t_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BeginDiscordOAuthInput()))
          return false;
        if (!this.f6t_1.equals(other.f6t_1))
          return false;
        if (!(this.g6t_1 === other.g6t_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'BeginDiscordOAuthInput');
    BeginDiscordOAuthInputClass = $;
  }
  return BeginDiscordOAuthInputClass;
}
//region block: exports
export {
  BeginDiscordOAuthInput as BeginDiscordOAuthInput22qiqfp1mhdpr,
};
//endregion

//# sourceMappingURL=BeginDiscordOAuthInput.mjs.map
